"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCurrency = exports.GetCurrenciesResponse = exports.CurrenciesData = exports.CurrencyData = exports.asDisplayCurrency = exports.asCurrency = exports.isDisplayCurrency = exports.isCurrency = exports.defaultCurrency = exports.displayCurrencies = exports.Currency = exports.currencies = void 0;
var typebox_1 = require("@sinclair/typebox");
exports.currencies = [
    "GBP",
    "EUR",
    "USD",
    "AUD",
    "NZD",
];
exports.Currency = typebox_1.Type.Union(exports.currencies.map(function (currency) { return typebox_1.Type.Literal(currency); }), {
    title: "Currency",
});
exports.displayCurrencies = [
    "GBP",
    "EUR",
    "USD",
];
exports.defaultCurrency = "USD";
var isCurrency = function (x) {
    switch (x) {
        case "GBP":
        case "EUR":
        case "USD":
        case "AUD":
        case "NZD":
            return true;
        default:
            return false;
    }
};
exports.isCurrency = isCurrency;
var isDisplayCurrency = function (x) {
    return exports.displayCurrencies.includes(x);
};
exports.isDisplayCurrency = isDisplayCurrency;
var asCurrency = function (x) { return (0, exports.isCurrency)(x) ? x : exports.defaultCurrency; };
exports.asCurrency = asCurrency;
var asDisplayCurrency = function (x) {
    return (0, exports.isDisplayCurrency)(x) ? x : exports.defaultCurrency;
};
exports.asDisplayCurrency = asDisplayCurrency;
exports.CurrencyData = typebox_1.Type.Object({
    convertFromUSD: typebox_1.Type.Number(),
}, { title: "CurrencyData" });
exports.CurrenciesData = typebox_1.Type.Object({
    AUD: exports.CurrencyData,
    EUR: exports.CurrencyData,
    GBP: exports.CurrencyData,
    NZD: exports.CurrencyData,
    USD: exports.CurrencyData,
}, {
    title: "CurrenciesData",
});
exports.GetCurrenciesResponse = typebox_1.Type.Object({
    data: exports.CurrenciesData,
}, { title: "GetCurrenciesResponse" });
var convertCurrency = function (data, convert) {
    if (convert.from === convert.to) {
        return convert.amount;
    }
    var usd = convert.amount / data[convert.from].convertFromUSD;
    var value = usd * data[convert.to].convertFromUSD;
    return Number(value.toPrecision(3));
};
exports.convertCurrency = convertCurrency;
